<script setup lang="ts">
  import type { MiniMonthCell } from '@/utils/calendar/date'
  import { cn } from '@/lib/utils'

  defineProps<{
    cells: MiniMonthCell[]
    weekdayLabels: string[]
  }>()

  const emit = defineEmits<{
    select: [date: Date]
  }>()
</script>

<template>
  <div>
    <div class="mb-1 grid grid-cols-7">
      <span
        v-for="label in weekdayLabels"
        :key="label"
        class="text-center text-[11px] text-[var(--cal-muted)]"
      >
        {{ label }}
      </span>
    </div>

    <div class="grid grid-cols-7 gap-y-0.5">
      <button
        v-for="(cell, index) in cells"
        :key="index"
        type="button"
        :disabled="!cell.currentMonth"
        :class="
          cn(
            `relative inline-flex size-7 items-center justify-center rounded-full text-xs focus:outline-none
            focus-visible:bg-[var(--cal-surface-hover)]`,
            cell.isSelected
              ? 'bg-primary font-medium text-primary-foreground hover:bg-primary-hover'
              : cell.isToday
                ? 'font-medium text-primary ring-1 ring-primary/40 hover:bg-[var(--cal-surface-hover)]'
                : cell.currentMonth
                  ? 'text-foreground hover:bg-[var(--cal-surface-hover)]'
                  : 'text-[var(--cal-muted)]/60 cursor-default'
          )
        "
        @click="cell.currentMonth && emit('select', cell.date)"
      >
        {{ cell.day }}
        <span
          v-if="cell.hasEvent && !cell.isSelected"
          class="absolute bottom-0.5 left-1/2 size-1 -translate-x-1/2 rounded-full bg-primary"
        />
      </button>
    </div>
  </div>
</template>
